/**
 * 평가 공유 버튼 (관리자 오더 상세) — 2026-09-02
 *
 * ERP 앱(eval_result_sections._PhotosShareLinkButton)과 동일 동작의 웹 판:
 *   GET /eval/orders/:id/photos/share-link → 24시간 유효 share-page URL 발급 →
 *   모바일 웹 = navigator.share 공유 시트 / 데스크톱 = 클립보드 복사.
 *   (90일 report-link 는 평가사 앱 전용 — 웹은 앱과 유효기간 정합, Jin 2026-09-02)
 *
 * 룰:
 *   - 서버가 주는 완성형 url 을 그대로 쓴다 (#324 — 클라 origin 조립 금지).
 *   - 공유 문구는 앱 l10n `evalPhotosShareLinkMessage` 와 동일하게 유지.
 */
import React, { useState, useEffect, useRef } from 'react';
import { API, authFetch } from '../utils/api';

// 앱 app_ko.arb evalPhotosShareLinkMessage 와 동일 문구 (드리프트 시 앱과 함께 수정)
var SHARE_MESSAGE_PREFIX = '검차 사진·동영상 보기·다운로드 (24시간 유효)\n';

export default function ReportShareButton({ orderId }) {
  var [busy, setBusy] = useState(false);
  var [copied, setCopied] = useState(false);
  var timerRef = useRef(null);
  useEffect(function() {
    return function() { if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  var flashCopied = function() {
    setCopied(true);
    timerRef.current = setTimeout(function() { setCopied(false); }, 2000);
  };

  var copyUrl = function(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(url).then(flashCopied, function() {
        window.prompt('아래 링크를 복사하세요', url);
      });
    }
    window.prompt('아래 링크를 복사하세요', url);
  };

  var handleClick = function() {
    if (busy) return;
    setBusy(true);
    authFetch(API + '/eval/orders/' + orderId + '/photos/share-link')
      .then(function(res) { return res.json(); })
      .then(function(d) {
        if (!d || !d.success || !d.url) {
          throw new Error((d && d.error) || '링크 발급 실패');
        }
        if (navigator.share) {
          return navigator.share({ text: SHARE_MESSAGE_PREFIX + d.url }).catch(function(e) {
            // 공유 시트를 사용자가 닫은 경우는 정상 종료
            if (e && e.name === 'AbortError') return;
            return copyUrl(d.url);
          });
        }
        return copyUrl(d.url);
      })
      .catch(function(e) {
        window.alert('리포트 링크 발급에 실패했습니다: ' + ((e && e.message) || e));
      })
      .finally(function() { setBusy(false); });
  };

  return (
    <button onClick={handleClick} disabled={busy} style={{
      fontSize: 12, padding: '5px 12px', border: '1px solid #d0d5dd', borderRadius: 6,
      background: '#fff', cursor: busy ? 'default' : 'pointer', fontWeight: 600,
      color: copied ? '#1B7F4B' : '#475569', whiteSpace: 'nowrap',
    }}>
      {busy ? '발급 중…' : copied ? '✅ 링크 복사됨' : '🔗 리포트 공유'}
    </button>
  );
}
